module.exports = __webpack_public_path__ + "images/logo-multiplus.jpg?e302b1c5d75835578dfe7420ce176f53";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/assets/images/fidelidade/logo-multiplus.jpg
// module id = 983
// module chunks = 0